import { Box, Typography } from '@mui/material';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import WebOutlinedIcon from '@mui/icons-material/WebOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import storeyviewLogo from '../../assets/logos/sv_logo_green.png';
import { theme } from '../../theme';
import Header from './Header';

const CREAM = '#faf7f1';

const FEATURE_CARDS = [
  {
    icon: <InventoryOutlinedIcon sx={{ color: theme.palette.primary.main, fontSize: '1.2rem' }} />,
    title: 'Live inventory & pricing',
    description: 'Real-time availability and holds, updated the moment a unit moves.',
  },
  {
    icon: <CampaignOutlinedIcon sx={{ color: theme.palette.primary.main, fontSize: '1.2rem' }} />,
    title: 'CRM & outreach',
    description: 'Every registrant captured and worked - mass and one-to-one email, text and calls.',
  },
  {
    icon: <WebOutlinedIcon sx={{ color: theme.palette.primary.main, fontSize: '1.2rem' }} />,
    title: 'Customer portals',
    description: 'Buyers see live inventory and pricing in a branded, self-serve portal.',
  },
  {
    icon: <DescriptionOutlinedIcon sx={{ color: theme.palette.primary.main, fontSize: '1.2rem' }} />,
    title: 'Deal writing',
    description: 'Generate and sign agreements on the spot, with minimal wait times.',
  },
  {
    icon: <BarChartOutlinedIcon sx={{ color: theme.palette.primary.main, fontSize: '1.2rem' }} />,
    title: 'Reporting & analytics',
    description: 'Deposit, mortgage and construction reporting in a click.',
  },
  {
    icon: <BadgeOutlinedIcon sx={{ color: theme.palette.primary.main, fontSize: '1.2rem' }} />,
    title: 'Realtor portals & logins',
    description: 'Named logins and full, exportable access for every client team.',
  },
];

const Features = () => {
  return (
    <Box sx={{ backgroundColor: CREAM, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header showLoginButton />

      <Box
        sx={{
          padding: '60px',
          '@media (max-width: 600px)': { padding: '30px 20px' },
        }}
      >
        <Typography sx={{ fontSize: '0.75rem', letterSpacing: '2px', color: theme.palette.secondary.main, fontWeight: 600, mb: 1 }}>
          FEATURES
        </Typography>
        <Typography sx={{ fontSize: '2.5rem', color: '#1a1a1a', lineHeight: 1.2, mb: 2, '@media (max-width: 600px)': { fontSize: '1.8rem' } }}>
          One platform, end to end.
        </Typography>
        <Typography sx={{ fontSize: '1rem', color: '#1a1a1a', mb: 4, maxWidth: '700px' }}>
          Everything from customer portals to CRM, deal writing and live inventory - the only sales platform in the
          city built by an in-house software team.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '24px',
          }}
        >
          {FEATURE_CARDS.map((card) => (
            <Box
              key={card.title}
              sx={{
                flex: '1 1 calc(33.333% - 16px)',
                minWidth: '260px',
                backgroundColor: '#ffffff',
                borderRadius: '6px',
                padding: '24px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.06)',
              }}
            >
              <Box
                sx={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '8px',
                  backgroundColor: '#eef0ec',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 2,
                }}
              >
                {card.icon}
              </Box>
              <Typography sx={{ fontWeight: 700, color: '#1a1a1a', mb: 1 }}>{card.title}</Typography>
              <Typography sx={{ fontSize: '0.9rem', color: '#1a1a1a' }}>{card.description}</Typography>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Footer */}
      <Box
        component="footer"
        sx={{
          backgroundColor: theme.palette.primary.main,
          padding: '40px 60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '20px',
          marginTop: 'auto',
          '@media (max-width: 600px)': { padding: '30px 20px' },
        }}
      >
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <img
              src={storeyviewLogo}
              alt="storeyview"
              style={{ height: '20px', filter: 'brightness(0) invert(1)' }}
            />
          </Box>
          <Typography sx={{ fontSize: '0.8rem', color: '#d8d8d0' }}>An RDS company</Typography>
          <Typography sx={{ fontSize: '0.8rem', color: theme.palette.secondary.main, letterSpacing: '1px' }}>STOREYVIEW.COM</Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: '24px' }}>
          <Typography
            component="a"
            href="https://rdsbrokerage.com/privacy/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontSize: '0.8rem', color: '#d8d8d0', letterSpacing: '1px', textDecoration: 'none' }}
          >
            PRIVACY
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Features;
